import { render } from "./InvitationRequestIcon.vue?vue&type=template&id=51336079"
import script from "./InvitationRequestIcon.vue?vue&type=script&lang=js"
export * from "./InvitationRequestIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__